import { useState, useEffect } from 'react';

export default function CTAFloating() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setVisible(window.scrollY > 300);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 md:hidden transition-transform duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-white/95 backdrop-blur-md border-t border-background-200/80 px-4 py-2.5 flex items-center gap-3">
        <a
          href="tel:+33980802242"
          className="btn-call text-sm flex-1 justify-center py-3"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-line text-sm"></i>
          </span>
          Appeler le 09 80 80 22 42
        </a>
        <p className="text-[10px] text-center text-foreground-500/40 font-body leading-tight shrink-0 max-w-[90px]">
          Devis gratuit<br />Garantie 10 ans
        </p>
      </div>
    </div>
  );
}